export default __webpack_public_path__ + "static/media/aakarsh.d5d88c7d.jpeg";